module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074e1_banner_800x600.8d172d81.png";